module.exports = __webpack_public_path__ + "5d33dad74f1660243f19e2263200da37.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/magic-wand-right.png
// module id = 2059
// module chunks = 0